import { render, staticRenderFns } from "./SpOrderClientsCreateEdit.vue?vue&type=template&id=593fb3da&scoped=true"
import script from "./SpOrderClientsCreateEdit.vue?vue&type=script&lang=js"
export * from "./SpOrderClientsCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./SpOrderClientsCreateEdit.vue?vue&type=style&index=0&id=593fb3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593fb3da",
  null
  
)

export default component.exports